<ng-container *ngIf="popupImageIndex < data?.length">
  <div class="close-btn-outer view-ads-popup">
    <button mat-mini-fab color="warn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="image-container">
    <img [src]="data[popupImageIndex].image" alt="Image" (click)="onSlideClick(data[popupImageIndex])" style="cursor: pointer;">
  </div>
</ng-container>
